import { Component, Output, EventEmitter } from '@angular/core';
import { ReservationsService } from '@app/shared/services/reservations.service';

@Component({
  selector: 'app-add-reservation',
  templateUrl: './add-reservation.component.html',
  styleUrls: ['./add-reservation.component.scss']
})
export class AddReservationComponent {

  public reservation : any = {
    user : ''
  };
  public validated : boolean = false;
  public loading : boolean = false;
  
  @Output() changed = new EventEmitter();

  constructor(
    private reservationService: ReservationsService
  ) {}

  validator() {
    let result : boolean = true;

    this.validated = false;
    if (this.reservation.user.length === 0) {
      result = false;
    }
    this.validated = result;
  }

  resetVariables() {
    this.reservation = {
      user: ''
    };
    this.validated = false;
  }

  submit() {
    // this.stationService.addStation(this.station).then((res) => {
    //   this.loading = false;
    //   this.changed.emit(null);
    //   this.resetVariables();
    //   UIkit.modal('#add-station').hide();
    // });
  }

}
